import CampaignCtrl from './controllers/index';
import CampaignMailEditorCtrl from './controllers/edit';
import CampaignSummaryCtrl from './controllers/summary';
import CampaignSmsEditorCtrl from "./controllers/smseditor";
import Transaction from './transactional.repository';
import Campaign from './campaign.repository';
import AbTest from './abTest.repository';
import campaignItem from './directives/campaign-item';
import campaignSettings from "./directives/campaign-settings";
import availabilityPanel from "../maileditor/directives/availability-panel";
import campaignContentPreview from "./directives/campaign-content-preview";
import routing from './campaign.routes';
import uirouter from 'angular-ui-router';
import smsText from "./directives/sms-text";

export default angular.module('app.campaign', [uirouter])
    .config(routing)
    .controller('CampaignCtrl', CampaignCtrl)
    .controller('CampaignMailEditorCtrl', CampaignMailEditorCtrl)
    .controller('CampaignSummaryCtrl', CampaignSummaryCtrl)
    .controller('CampaignSmsEditorCtrl', CampaignSmsEditorCtrl)
    .directive('campaignItem', () => new campaignItem)
    .directive('campaignSettings', () => new campaignSettings)
    .directive('availabilityPanel', () => new availabilityPanel)
    .directive('campaignContentPreview', () => new campaignContentPreview)
    .directive('smsText', () => new smsText)
    .service('Campaign', Campaign)
    .service('Transaction', Transaction)
    .service('AbTest', AbTest)
    .name;

